export default __webpack_public_path__ + "static/case2_img_6@2x-9a5dc6e16aa98315f5a62430cf09abf5.webp";